'use strict';
var CategoryStyle;
(function (CategoryStyle) {
    CategoryStyle["Tabs"] = "tabs";
    CategoryStyle["Chips"] = "chips";
    CategoryStyle["None"] = "none";
    CategoryStyle["Titles"] = "titles";
})(CategoryStyle || (CategoryStyle = {}));
export default CategoryStyle;
